import * as React from 'react';

import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2

import DetailsHeader from '../DetailsHeader';
import DetailsContent from '../DetailsContent';

import {date} from "../../utils/datetime";

import { sex as sexList, genus as genusList} from "../../models/categories";
import { useQuery } from '@tanstack/react-query'
import { listLabel } from "../../utils/lists";

export default function AnimalDetails({animal,...props}) {

    console.log(animal);

    const {isLoading, data} = useQuery({
        queryKey: ['sexgenus'],
        queryFn: async() => {
            return {
                sex: await sexList(),
                genus: await genusList(),
            };
        },
        networkMode: "offlineFirst",
    });

    return (
        <Grid container columnSpacing={2} rowSpacing={2}>
            <Grid xs={6} sm={6}> 
                <DetailsHeader>Sex</DetailsHeader>
                <DetailsContent>{!isLoading && listLabel(animal.sex,data.sex)}</DetailsContent>
            </Grid>
            <Grid xs={6} sm={6}> 
                <DetailsHeader>Phylum</DetailsHeader>
                <DetailsContent>{animal.phylum}</DetailsContent>
            </Grid>
            <Grid xs={6} sm={6}> 
                <DetailsHeader>Class</DetailsHeader>
                <DetailsContent>{animal.classes}</DetailsContent>
            </Grid>
            <Grid xs={6} sm={6}> 
                <DetailsHeader>Order</DetailsHeader>
                <DetailsContent>{animal.order}</DetailsContent>
            </Grid>
            <Grid xs={6} sm={6}> 
                <DetailsHeader>Genus</DetailsHeader>
                <DetailsContent>{animal.genus}</DetailsContent>
            </Grid>
            <Grid xs={6} sm={6}> 
                <DetailsHeader>Species</DetailsHeader>
                <DetailsContent>{animal.species}</DetailsContent>
            </Grid>
            <Grid xs={6} sm={6}> 
                <DetailsHeader>Date Born</DetailsHeader>
                <DetailsContent>{date(animal.born_on)} ({(animal.born_on_is_estimated === "1") ? "Estimated" : "Known"})</DetailsContent>
            </Grid>

            {animal.died_on && <Grid xs={6} sm={6}> 
                <DetailsHeader>Date of Death</DetailsHeader>
                <DetailsContent>{date(animal.died_on)}</DetailsContent>
            </Grid>}

            <Grid xs={12} sm={6}> 
                <DetailsHeader>Date Entered Captivity</DetailsHeader>
                <DetailsContent>{date(animal.entered_captivity_on)} ({(animal.entered_captivity_on_is_estimated === "1") ? "Estimated" : "Known"})</DetailsContent>
            </Grid>
            <Grid xs={12} sm={6}> 
                <DetailsHeader>Date Arrived At Current Institution</DetailsHeader>
                <DetailsContent>{date(animal.arrived_on)} ({(animal.arrived_on_is_estimated === "1") ? "Estimated" : "Known"})</DetailsContent>
            </Grid>


            {animal.departed_on && <Grid xs={12} sm={6}> 
                <DetailsHeader>Date Departed</DetailsHeader>
                <DetailsContent>{date(animal.departed_on)}</DetailsContent>
            </Grid>}

            {animal.departed_on && <Grid xs={12} sm={6}> 
                <DetailsHeader>Date Departed Notes</DetailsHeader>
                <DetailsContent>{animal.additional_information_about_departure || ''}</DetailsContent>
            </Grid>}

        </Grid>
    );
}